export default {
      id: "ic-misc-person-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-misc-person-usage",
      toString: function () {
        return this.url;
      }
    }